import React, { useState, useEffect } from 'react';
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import './exchangeWays.css';
import Menu from '../../elements/Menu/menu';

export default function AdminExchangeWays() {
    const [state, setState] = useState({
        allExchangeWays: null,
        mode: 'BUY',
        loader: false,

        fiatInCurrenciesArray: null,
        fiatOutCurrenciesArray: null,
        cryptoInCurrenciesArray: null,
        cryptoOutCurrenciesArray: null,
        inPaywaysArray: null,
        outPaywaysArray: null,
        providersArray: null,
        rateTypesArray: null,

        inCurrencyMainFilter: 'DEFAULT',
        outCurrencyMainFilter: 'DEFAULT',
        inPaywayMainFilter: 'DEFAULT',
        outPaywayMainFilter: 'DEFAULT',
        providerMainFilter: 'DEFAULT',
        rateTypeMainFilter: 'DEFAULT',

        inCurrencyFilter: 'DEFAULT',
        outCurrencyFilter: 'DEFAULT',
        inPaywayFilter: 'DEFAULT',
        outPaywayFilter: 'DEFAULT',
        providerFilter: 'DEFAULT',
        rateTypeFilter: 'DEFAULT',

        changes: null
    });

    useEffect(() => {
        const main = async () => {
            await axios.get(config.backendUrl + '/data/all-admin-prerequest', { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } })
            .then(response => {
                // console.log(response.data); // for debugging
                setState({ ...state, ...response.data })
            })
            .catch(error => alert(error.response ? error.response.data.message : error.message));
        };
        main();
    }, []);

    // Renders
    const sortAllExchangeWays = (resData) => {
        const tmpObj = { ...resData };
    
        for (let type in tmpObj) {
            tmpObj[type] = tmpObj[type].sort(getSortCallback('provider'));

            switch (type) {
                case 'sell':
                    tmpObj[type] = tmpObj[type].sort(getSortCallback('outCurrencyCode'));
                    tmpObj[type] = tmpObj[type].sort(getSortCallback('outPaywayCode'));
                    break;
            
                default:
                    tmpObj[type] = tmpObj[type].sort(getSortCallback('inCurrencyCode'));
                    tmpObj[type] = tmpObj[type].sort(getSortCallback('inPaywayCode'));
                    break;
            }
        }
    
        return tmpObj;
    };

    const getSortCallback = (param) => {
        switch (param) {
            case 'provider':
                return (a, b) => {
                    if (a.provider > b.provider) { return 1; }
                    if (a.provider < b.provider) { return -1; }
                    return 0;
                };
        
            case 'inCurrencyCode':
                return (a, b) => {
                    if (a.inCurrency.code > b.inCurrency.code) { return 1; }
                    if (a.inCurrency.code < b.inCurrency.code) { return -1; }
                    return 0;
                };
    
            case 'outCurrencyCode':
                return (a, b) => {
                    if (a.outCurrency.code > b.outCurrency.code) { return 1; }
                    if (a.outCurrency.code < b.outCurrency.code) { return -1; }
                    return 0;
                };
    
            case 'inPaywayCode':
                return (a, b) => {
                    if (a.inPaywayCode > b.inPaywayCode) { return 1; }
                    if (a.inPaywayCode < b.inPaywayCode) { return -1; }
                    return 0;
                };
    
            case 'outPaywayCode':
                return (a, b) => {
                    if (a.outPaywayCode > b.outPaywayCode) { return 1; }
                    if (a.outPaywayCode < b.outPaywayCode) { return -1; }
                    return 0;
                };

            default: return null;
        }
    };

    const renderModes = () => {
        if (!state.allExchangeWays) { return; }

        return(
            <div className="exchangeWays__modeSelector_wrapper">
                {
                  Object.keys(state.allExchangeWays).map((modeName, index) => {
                    return(
                        <>
                            <input type="radio" name="mode" id={ modeName + 'RadioInput' }
                                value={ modeName.toUpperCase() } onChange={event => modeHandler(event.target.value)} checked={ modeName.toUpperCase() === state.mode } />
                            <label className="exchangeWays__modeSelector_label" htmlFor={ modeName + 'RadioInput' }>{ modeName.toUpperCase() }</label>
                        </>
                    );
                  })
                }
            </div>
        );
    };

    const renderProviderFees = (fee) => {
        if (!fee.amount) { return(<></>); }
        return(
            <div className="exchangeWays__providerFee_wrapper">
                <div className="exchangeWays__fees_wrapper" >
                    <span>Type:</span>
                    <span>{ fee.type }</span>
                </div>
                <div className="exchangeWays__fees_wrapper" >
                    <span>Amount:</span>
                    <span>{ fee.amount }</span>
                </div>
            </div>
        );
    };

    const renderTrusteeFees = (fee, wayInfo, feeSide) => {
        if (!fee.amount) { return(<></>); }
        return(
            <>
                <div className="exchangeWays__fees_wrapper" >
                    <span>Type:</span>
                    <span>{ fee.type }</span>
                </div>
                <div className="exchangeWays__fees_wrapper" >
                    <span>Amount:</span>
                    <input type="number" value={ fee.amount } disabled={ isProviderEnabledForConfigure(wayInfo.provider) } min="0"
                        onChange={ event => inputHandler(event, (feeSide.toLowerCase() + 'Fee'), wayInfo.exchangeWayId, { feeType: fee.type, feeSide }) } />
                </div>
                <div className="exchangeWays__fees_wrapper" >
                    <span>Discount:</span>
                    <input type="number" value={ fee.discount } disabled={ isProviderEnabledForConfigure(wayInfo.provider) } min="0"
                        onChange={ event => inputHandler(event, (feeSide.toLowerCase() + 'TrusteeFeeDiscount'), wayInfo.exchangeWayId, { feeType: fee.type, feeSide }) } />
                </div>
            </>
        );
    };

    const isProviderEnabledForConfigure = (providerName) => {
        switch (providerName) {
            case '365CASH':
            case 'CHANGELLY':
            case 'SWAPY':
            case 'CHANGE_NOW':
            case 'MINE_EXCHANGE':
            case 'MERCURYO':
            case 'MOON_PAY':
            case 'ALICE_BOB':
            case 'KASSA':
                return true;
            default: return false;
        }
    };

    const applyFilters = () => {
        let allWays = state.allExchangeWays[ state.mode.toLowerCase() ];

        if (state.inCurrencyFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.inCurrency.code === state.inCurrencyFilter);
        }
        if (state.outCurrencyFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.outCurrency.code === state.outCurrencyFilter);
        }
        if (state.inPaywayFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.inPaywayCode === state.inPaywayFilter);
        }
        if (state.outPaywayFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.outPaywayCode === state.outPaywayFilter);
        }
        if (state.providerFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.provider === state.providerFilter);
        }
        if (state.rateTypeFilter !== 'DEFAULT') {
            allWays = allWays.filter(way => way.rateType === state.rateTypeFilter);
        }

        return allWays;
    };

    const renderTable = () => {
        if (!state.allExchangeWays) { return; }

        const wayArray = applyFilters();

        return(
            <div className="exchangeWays__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <div>Is active for WALLET</div>
                                <div className="table__checkbox">
                                    <input style={{ width: 25 }} type="checkbox" onChange={ enableAllHandler('isActiveForWallet') }/>
                                    <span>enable all</span>
                                </div>
                            </th>
                            <th>
                                <div>Is active for SITE</div>
                                <div className="table__checkbox">
                                    <input style={{ width: 25 }} type="checkbox" onChange={ enableAllHandler('isActiveForSite') }/>
                                    <span>enable all</span>
                                </div>
                            </th>
                            <th>
                                <div>Is active for PARTNERS</div>
                                <div className="table__checkbox">
                                    <input style={{ width: 25 }} type="checkbox" onChange={ enableAllHandler('isActiveForPartners') }/>
                                    <span>enable all</span>
                                </div>
                            </th>
                            <th>Is active</th>
                            <th>Is enabled</th>
                            <th>Way ID</th>
                            <th>
                                Exchange way
                                <div>
                                    <select value={ state.inCurrencyFilter } onChange={ filterChangeHandler('inCurrency') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.inCurrency.code))).sort().map(currencyCode => {
                                                return(<option value={ currencyCode }>{ currencyCode }</option>);
                                            })
                                        }
                                    </select>
                                    >>
                                    <select value={ state.outCurrencyFilter } onChange={ filterChangeHandler('outCurrency') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.outCurrency.code))).sort().map(currencyCode => {
                                                return(<option value={ currencyCode }>{ currencyCode }</option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </th>
                            <th>
                                In payway
                                <div>
                                    <select value={ state.inPaywayFilter } onChange={ filterChangeHandler('inPayway') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.inPaywayCode))).sort().map(paywayCode => {
                                                return(<option value={ paywayCode }>{ paywayCode }</option>);
                                            })
                                        }
                                    </select>
                                </div>    
                            </th>
                            <th>
                                Out payway
                                <div>
                                    <select value={ state.outPaywayFilter } onChange={ filterChangeHandler('outPayway') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.outPaywayCode))).sort().map(paywayCode => {
                                                return(<option value={ paywayCode }>{ paywayCode }</option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </th>
                            <th>
                                Provider
                                <div>
                                    <select value={ state.providerFilter } onChange={ filterChangeHandler('provider') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.provider))).sort().map(provider => {
                                                return(<option value={ provider }>{ provider.toLowerCase() }</option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </th>
                            <th>
                                Rate type
                                <div>
                                    <select value={ state.rateTypeFilter } onChange={ filterChangeHandler('rateType') }>
                                        <option value="DEFAULT" disabled>filter</option>
                                        {
                                            Array.from(new Set(state.allExchangeWays[ state.mode.toLowerCase() ].map(way => way.rateType))).sort().map(rateType => {
                                                return(<option value={ rateType }>{ rateType.toLowerCase() }</option>);
                                            })
                                        }
                                    </select>
                                </div>
                            </th>
                            <th>In provider fees</th>
                            <th>Out provider fees</th>
                            <th>In Trustee fees</th>
                            <th>Out Trustee fees</th>
                            <th>Trustee min limit</th>
                            <th>Trustee max limit</th>
                            <th>Cashback fee</th>
                        </tr>
                    </thead>
                    <tbody>
                        { wayArray.map((wayInfo, index) => {
                            return(
                                <tr key={ index }>
                                    <td><input type="checkbox" checked={ wayInfo.isActiveForWallet } onChange={ event => inputHandler(event, 'isActiveForWallet', wayInfo.exchangeWayId) } /></td>
                                    <td><input type="checkbox" checked={ wayInfo.isActiveForSite } onChange={ event => inputHandler(event, 'isActiveForSite', wayInfo.exchangeWayId) } /></td>
                                    <td><input type="checkbox" checked={ wayInfo.isActiveForPartners } onChange={ event => inputHandler(event, 'isActiveForPartners', wayInfo.exchangeWayId) } /></td>
                                    <td><input type="checkbox" checked={ wayInfo.isActive } disabled /></td>
                                    <td><input type="checkbox" checked={ wayInfo.isEnabled } disabled /></td>
                                    <td>{ wayInfo.exchangeWayId }</td>
                                    <td>
                                        <span onDoubleClick={ () => doubleClickHandler(wayInfo.inCurrency.code, 'CURRENCY', 'IN') } >{ wayInfo.inCurrency.code }</span>>>
                                        <span onDoubleClick={ () => doubleClickHandler(wayInfo.outCurrency.code, 'CURRENCY', 'OUT') } >{ wayInfo.outCurrency.code }</span>
                                    </td>
                                    <td><span onDoubleClick={ () => doubleClickHandler(wayInfo.inPaywayCode, 'PAYWAY', 'IN') } >{ wayInfo.inPaywayCode }</span></td>
                                    <td><span onDoubleClick={ () => doubleClickHandler(wayInfo.outPaywayCode, 'PAYWAY', 'OUT') } >{ wayInfo.outPaywayCode }</span></td>
                                    <td><span onDoubleClick={ () => doubleClickHandler(wayInfo.provider, 'PROVIDER', null) } >{ wayInfo.provider }</span></td>
                                    <td>{ wayInfo.rateType }</td>
                                    <td>{ wayInfo.fees.providerFee.in.map(fee => renderProviderFees(fee)) }</td>
                                    <td>{ wayInfo.fees.providerFee.out.map(fee => renderProviderFees(fee)) }</td>
                                    <td>{ wayInfo.fees.trusteeFee.in.map(fee => renderTrusteeFees(fee, wayInfo, 'IN')) }</td>
                                    <td>{ wayInfo.fees.trusteeFee.out.map(fee => renderTrusteeFees(fee, wayInfo, 'OUT')) }</td>
                                    <td><input type="number" value={ wayInfo.trusteeLimits.min } onChange={ event => inputHandler(event, 'trusteeMinLimit', wayInfo.exchangeWayId) } min="0" /></td>
                                    <td><input type="number" value={ wayInfo.trusteeLimits.max } onChange={ event => inputHandler(event, 'trusteeMaxLimit', wayInfo.exchangeWayId) } min="0" /></td>
                                    <td>
                                        <input type="checkbox" checked={ wayInfo.cashbackFee.isActive } disabled={ isProviderEnabledForConfigure(wayInfo.provider)}
                                            onChange={ event => inputHandler(event, 'cashbackFeeCheckbox', wayInfo.exchangeWayId) } />
                                        <input type="number" value={ wayInfo.cashbackFee.amount } disabled={ isProviderEnabledForConfigure(wayInfo.provider) }
                                            onChange={ event => inputHandler(event, 'cashbackFeeAmount', wayInfo.exchangeWayId) } min="0" />
                                    </td>
                                </tr>
                            )
                        }) }
                    </tbody>
                </table>
            </div>
        );
    };

    const renderFilters = () => {
        if (!state.fiatInCurrenciesArray && !state.fiatOutCurrenciesArray && !state.cryptoInCurrenciesArray && !state.cryptoOutCurrenciesArray &&
        !state.inPaywaysArray && !state.outPaywaysArray && !state.providersArray && !state.rateTypesArray) { return; }

        return(
            <div className="exchangeWays__filters_wrapper">
                <select className="exchangeWays__providerFee_wrapper" value={ state.inCurrencyMainFilter } onChange={ filterChangeHandler('inCurrencyMain') }>
                    <option value="DEFAULT">in currency</option>
                    <option disabled>--- FIAT ---</option>
                    {
                        state.fiatInCurrenciesArray ? state.fiatInCurrenciesArray.map(currencyCode => {
                            return(<option value={ currencyCode }>{ currencyCode }</option>);
                        }) : null
                    }
                    <option disabled>--- CRYPTO ---</option>
                    {
                        state.cryptoInCurrenciesArray ? state.cryptoInCurrenciesArray.map(currencyCode => {
                            return(<option value={ currencyCode }>{ currencyCode }</option>);
                        }) : null
                    }
                </select>

                <select className="exchangeWays__providerFee_wrapper" value={ state.outCurrencyMainFilter } onChange={ filterChangeHandler('outCurrencyMain') }>
                    <option value="DEFAULT">out currency</option>
                    <option disabled>--- FIAT ---</option>
                    {
                        state.fiatOutCurrenciesArray ? state.fiatOutCurrenciesArray.map(currencyCode => {
                            return(<option value={ currencyCode }>{ currencyCode }</option>);
                        }) : null
                    }
                    <option disabled>--- CRYPTO ---</option>
                    {
                        state.cryptoOutCurrenciesArray ? state.cryptoOutCurrenciesArray.map(currencyCode => {
                            return(<option value={ currencyCode }>{ currencyCode }</option>);
                        }) : null
                    }
                </select>

                <select className="exchangeWays__providerFee_wrapper" value={ state.inPaywayMainFilter } onChange={ filterChangeHandler('inPaywayMain') }>
                    <option value="DEFAULT">in payway</option>
                    {
                        state.inPaywaysArray ? state.inPaywaysArray.map(paywayCode => {
                            return(<option value={ paywayCode }>{ paywayCode }</option>);
                        }) : null
                    }
                </select>

                <select className="exchangeWays__providerFee_wrapper" value={ state.outPaywayMainFilter } onChange={ filterChangeHandler('outPaywayMain') }>
                    <option value="DEFAULT">out payway</option>
                    {
                        state.outPaywaysArray ? state.outPaywaysArray.map(paywayCode => {
                            return(<option value={ paywayCode }>{ paywayCode }</option>);
                        }) : null
                    }
                </select>

                <select className="exchangeWays__providerFee_wrapper" value={ state.providerMainFilter } onChange={ filterChangeHandler('providerMain') }>
                    <option value="DEFAULT">provider</option>
                    {
                        state.providersArray ? state.providersArray.map(providerName => {
                            return(<option value={ providerName }>{ providerName }</option>);
                        }) : null
                    }
                </select>

                <select className="exchangeWays__providerFee_wrapper" value={ state.rateTypeMainFilter } onChange={ filterChangeHandler('rateTypeMain') }>
                    <option value="DEFAULT">rate type</option>
                    {
                        state.rateTypesArray ? state.rateTypesArray.map(rateType => {
                            return(<option value={ rateType }>{ rateType }</option>);
                        }) : null
                    }
                </select>

                <button onClick={ findButtonHandler }>Find</button>
            </div>
        );
    };

    // Handlers
    const modeHandler = mode => setState({
        ...state,
        mode,
        inCurrencyFilter: 'DEFAULT',
        outCurrencyFilter: 'DEFAULT',
        inPaywayFilter: 'DEFAULT',
        outPaywayFilter: 'DEFAULT',
        providerFilter: 'DEFAULT'
    });

    const inputHandler = (event, type, exchangeWayId, extraData = null) => {
        const allExchangeWays = { ...state.allExchangeWays };
        const changes = { ...state.changes };

        const { newAllExchangeWays, newChanges } = getChanges(event, type, exchangeWayId, allExchangeWays, changes, extraData);

        setState(state => { return {
            ...state,
            allExchangeWays: newAllExchangeWays,
            changes: newChanges
        }; });
    };

    const getChanges = (event, type, exchangeWayId, allExchangeWays, changes, extraData) => {
        const arrayIndex = allExchangeWays[ state.mode.toLowerCase() ].findIndex(wayInfo => wayInfo.exchangeWayId === exchangeWayId);
        if (!changes[ exchangeWayId ]) { changes[ exchangeWayId ] = {}; }
        let feeArrayIndex;

        switch (type) {
            case 'isActiveForWallet':
            case 'isActiveForSite':
            case 'isActiveForPartners':
                changes[ exchangeWayId ].isActiveForWallet = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActiveForWallet;
                changes[ exchangeWayId ].isActiveForSite = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActiveForSite;
                changes[ exchangeWayId ].isActiveForPartners = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActiveForPartners;
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ][type] = event.target.checked;
                changes[ exchangeWayId ][type] = event.target.checked;
                break;

            case 'inFee':
                feeArrayIndex = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ]
                .findIndex(fee => fee.type === extraData.feeType);
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ][ feeArrayIndex ].amount = event.target.value;
                changes[ exchangeWayId ].inTrusteeFee ?
                    changes[ exchangeWayId ].inTrusteeFee[ extraData.feeType ] = event.target.value:
                    changes[ exchangeWayId ].inTrusteeFee = { [ extraData.feeType ]: event.target.value };
                break;

            case 'inTrusteeFeeDiscount':
                feeArrayIndex = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ]
                .findIndex(fee => fee.type === extraData.feeType);
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ][ feeArrayIndex ].discount = event.target.value;
                changes[ exchangeWayId ].inTrusteeFeeDiscount ?
                    changes[ exchangeWayId ].inTrusteeFeeDiscount[ extraData.feeType ] = event.target.value:
                    changes[ exchangeWayId ].inTrusteeFeeDiscount = { [ extraData.feeType ]: event.target.value };
                break;

            case 'outFee':
                feeArrayIndex = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ]
                .findIndex(fee => fee.type === extraData.feeType);
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ][ feeArrayIndex ].amount = event.target.value;
                changes[ exchangeWayId ].outTrusteeFee ?
                    changes[ exchangeWayId ].outTrusteeFee[ extraData.feeType ] = event.target.value:
                    changes[ exchangeWayId ].outTrusteeFee = { [ extraData.feeType ]: event.target.value };
                break;

            case 'outTrusteeFeeDiscount':
                feeArrayIndex = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ]
                .findIndex(fee => fee.type === extraData.feeType);
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].fees.trusteeFee[ extraData.feeSide.toLowerCase() ][ feeArrayIndex ].discount = event.target.value;
                changes[ exchangeWayId ].outTrusteeFeeDiscount ?
                    changes[ exchangeWayId ].outTrusteeFeeDiscount[ extraData.feeType ] = event.target.value:
                    changes[ exchangeWayId ].outTrusteeFeeDiscount = { [ extraData.feeType ]: event.target.value };
                break;

            case 'trusteeMinLimit':
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].trusteeLimits.min = event.target.value;
                changes[ exchangeWayId ].trusteeLimits ?
                    changes[ exchangeWayId ].trusteeLimits.min = event.target.value :
                    changes[ exchangeWayId ].trusteeLimits = { min: event.target.value };
                break;

            case 'trusteeMaxLimit':
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].trusteeLimits.max = event.target.value;
                changes[ exchangeWayId ].trusteeLimits ?
                    changes[ exchangeWayId ].trusteeLimits.max = event.target.value :
                    changes[ exchangeWayId ].trusteeLimits = { max: event.target.value };
                break;

            case 'cashbackFeeCheckbox':
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].cashbackFee.isActive = event.target.checked;
                changes[ exchangeWayId ].cashbackFee ?
                    changes[ exchangeWayId ].cashbackFee.isActive = event.target.checked :
                    changes[ exchangeWayId ].cashbackFee = { isActive: event.target.checked };
                break;

            case 'cashbackFeeAmount':
                allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].cashbackFee = { isActive: true, amount: event.target.value };
                changes[ exchangeWayId ].cashbackFee = { isActive: true, amount: event.target.value };
                break;
        
            default: return;
        }

        return { newAllExchangeWays: allExchangeWays, newChanges: changes };
    };

    const doubleClickHandler = (code, type, side) => {
        // const allExchangeWays = { ...state.allExchangeWays };
        // const changes = { ...state.changes };
        // let exchangeWaysArray = [ ...allExchangeWays[ state.mode.toLowerCase() ] ];

        // switch (type) {
        //     case 'CURRENCY':
        //         exchangeWaysArray = exchangeWaysArray.filter(wayInfo => wayInfo[ side.toLowerCase() + 'Currency' ].code === code);
        //         break;

        //     case 'PAYWAY':
        //         exchangeWaysArray = exchangeWaysArray.filter(wayInfo => wayInfo[ side.toLowerCase() + 'PaywayCode' ] === code);
        //         break;

        //     case 'PROVIDER':
        //         exchangeWaysArray = exchangeWaysArray.filter(wayInfo => wayInfo.provider === code);
        //         break;
        
        //     default: return;
        // }

        // let arrayIndex;

        // for (let i = 0; i < exchangeWaysArray.length; i++) {
        //     arrayIndex = allExchangeWays[ state.mode.toLowerCase() ].findIndex(wayInfo => wayInfo.exchangeWayId === exchangeWaysArray[i].exchangeWayId);
        //     allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActive = !allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActive;

        //     if (!changes[ exchangeWaysArray[i].exchangeWayId ]) { changes[ exchangeWaysArray[i].exchangeWayId ] = {}; }
        //     changes[ exchangeWaysArray[i].exchangeWayId ].isActive = allExchangeWays[ state.mode.toLowerCase() ][ arrayIndex ].isActive;
        // }

        // setState(state => { return { ...state, allExchangeWays, changes }; });
    };

    const saveButtonHandler = async () => {
        const token = prompt('Enter Google 2FA');

        if (!token) {
            alert('Invalid Google 2FA');
            return;
        }

        const body = {
            exchangeWayChanges: state.changes,
            google2faToken: token
        };
        // console.log(body); // for debugging

        await axios.post(config.backendUrl + '/admin/save-exchange-ways', body)
        .then(() => alert('Success'))
        .catch(error => {
            console.log(error.message);
            console.log(error.response.data);
            alert(error.response.data.message);
        });
    };

    const filterChangeHandler = (filterType) => (event) => {
        const newState = { ...state };
        newState[ filterType + 'Filter' ] = event.target.value;
        setState(() => { return newState; });
    };

    const enableAllHandler = (field) => (event) => {
        const wayArray = applyFilters();

        let allExchangeWays = { ...state.allExchangeWays };
        let changes = { ...state.changes };
        let response;

        for (let i = 0; i < wayArray.length; i++) {
            response = getChanges(event, field, wayArray[i].exchangeWayId, allExchangeWays, changes);
            allExchangeWays = response.newAllExchangeWays;
            changes = response.newChanges;
        }

        setState(state => { return { ...state, allExchangeWays, changes }; });
    };

    const findButtonHandler = async () => {
        setState(state => { return { ...state, loader: true }; });

        let params = '?';
        if (state.inCurrencyMainFilter !== 'DEFAULT') {
            params += 'inCurrencyCode=' + state.inCurrencyMainFilter + '&';
        }
        if (state.outCurrencyMainFilter !== 'DEFAULT') {
            params += 'outCurrencyCode=' + state.outCurrencyMainFilter + '&';
        }
        if (state.inPaywayMainFilter !== 'DEFAULT') {
            params += 'inPaywayCode=' + state.inPaywayMainFilter + '&';
        }
        if (state.outPaywayMainFilter !== 'DEFAULT') {
            params += 'outPaywayCode=' + state.outPaywayMainFilter + '&';
        }
        if (state.providerMainFilter !== 'DEFAULT') {
            params += 'providerName=' + state.providerMainFilter + '&';
        }
        if (state.rateTypeMainFilter !== 'DEFAULT') {
            params += 'rateType=' + state.rateTypeMainFilter + '&';
        }

        const url = config.backendUrl + '/data/find-exchange-ways' + params.slice(0, -1);
        // console.log(url); // for debugging

        await axios.get(url, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .then(response => {
            // console.log(response.data); // for debugging
            const allExchangeWays = response.data;

            let mode;
            if (allExchangeWays.buy.length) { mode = 'BUY'; }
            else if (allExchangeWays.sell.length) { mode = 'SELL'; }
            else if (allExchangeWays.exchange.length) { mode = 'EXCHANGE'; }

            setState(state => { return {
                ...state,
                allExchangeWays: sortAllExchangeWays(allExchangeWays),
                loader: false,
                mode: mode || 'BUY'
            } });
        })
        .catch(error => alert(error.response ? error.response.data.message : error.message));
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div className="exchangeWays__wrapper">
                { renderFilters() }
                { state.loader ? <div className="exchangeWays__loader_wrapper">Loading...</div> : null }
                { renderModes() }
                { renderTable() }
                { state.allExchangeWays ? <button className="exchangeWays__saveButton" onClick={ saveButtonHandler } >Save changes</button> : null }
            </div>
        </>
    );
};
